import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Stat} from '../../../types/stats';

export type ResultSliceInterface = {
  value: Stat | null;
};

/* eslint-disable */
const DEV_MOCK_RESULT: Stat | null = process.env.NODE_ENV === 'development' ? {
  count: 4,
  minPriority: 3,
  model: {
    model: 'atlas',
    modelName: 'Atlas',
    code: 'VW1701_VW1701',
    priority: 3,
  },
  result: {
    title: 'The Atlas',
    subTitle: 'Our super spacious 7-seater',
    descriptions: 'For the family that never sits still. Hockey bags, camping gear, more friends – in the easy-to-access third row – the Atlas makes room for every chapter of the adventure. With seating for 7 and serious towing power, it’s built for your biggest plans — or choose the available Captain’s Chair package, which comes with seating for 6 in the Highline and Execline.',
    highlights: [
      'Starting at $54,481',
      '7 seats',
      '2,735 L of cargo space (with rear seats folded)',
      '5,000 lb towing capacity, braked',
    ],
    cta: {
      learn: {
        url: 'https://www.vw.ca/en/models/new-vehicles/suv/2026-atlas.html',
        title: 'Learn more about the Atlas',
        linkName: 'Learn more about the Atlas',
      },
      build: {
        url: 'https://www.vw.ca/en/configurator.html/__app/2026-atlas.app',
        title: 'Build your Atlas',
        linkName: 'Build your Atlas',
      },
    },
    image: {
      url: 'https://vw-canada-websites.s3.amazonaws.com/campaigns/suvw/results/atlas/SUVW_PollPage_Results_Atlas.png',
      alt: 'The pure grey Atlas Execline in a park, with a group of people in red soccer jerseys walking away, one holding a football. with a blue circle in the corner indicating it’s a 7-seater.',
    },
    images: [
      {
        url: 'https://vw-canada-websites.s3.amazonaws.com/campaigns/suvw/results/atlas/SUVW_PollPage_Results_Atlas_1.png',
        alt: 'Interior view of the Atlas Execline featuring the touch screen display and steering wheel.',
      },
      {
        url: 'https://vw-canada-websites.s3.amazonaws.com/campaigns/suvw/results/atlas/SUVW_PollPage_Results_Atlas_2.png',
        alt: 'Exterior view of the pure grey Atlas Execline parked on the side of the road near a park with the trunk open.',
      },
      {
        url: 'https://vw-canada-websites.s3.amazonaws.com/campaigns/suvw/results/atlas/SUVW_PollPage_Results_Atlas_3.png',
        alt: 'Interior close up view of the seats and sunroof.',
      },
    ],
    imageRecommended: {
      url: 'https://vw-canada-websites.s3.amazonaws.com/campaigns/suvw/recommended/SUVW_atlas.png',
      alt: 'The pure grey Atlas Execline in a park, with a group of people in red soccer jerseys walking away, one holding a football. with a blue circle in the corner indicating it’s a 7-seater.',
    },
    carlineName: 'Atlas',
  },
} : null;
/* eslint-enable */

const initialState: ResultSliceInterface = {
  value: DEV_MOCK_RESULT,
};

const ResultSlice = createSlice({
  name: 'resultSlice',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Stat>) => {
      state.value = action.payload;
    },

    reset: () => initialState,
  },
});

export const {set, reset} = ResultSlice.actions;
export default ResultSlice.reducer;
